import type { TQueryConstructor } from '@hozana/api/types'

import type { TGuide, TGuideTree } from 'modules/guide/types'

export const getGuideQuery: TQueryConstructor<{ path: string }, TGuide> = ({ path }) => ({
  queryKey: `getGuide${path}`,
  url: `/guide`,
  params: {
    path,
  },
})

export const getGuidesQuery: TQueryConstructor<void, TGuideTree[]> = () => ({
  queryKey: `getGuides`,
  url: `/guides`,
})
